var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-field",
    {
      attrs: {
        helper: _vm.$t(_vm.getHelper),
        error: _vm.error,
        warning: _vm.showDisableWarning,
        "warning-label": _vm.$t("not_allowed_to_edit_the_class_file")
      }
    },
    [
      _c("q-uploader", {
        ref: "uploader",
        attrs: {
          "auto-expand": "",
          "hide-upload-button": "",
          inverted: "",
          color: "primary",
          url: "",
          multiple: _vm.multiple,
          extensions: _vm.getExtensions,
          "upload-factory": _vm.uploadFile,
          filter: _vm.filterFiles,
          disable: _vm.disable,
          "float-label": _vm.imageSize
        },
        on: {
          add: _vm.fileAdded,
          "remove:abort": _vm.uploadCancel,
          "remove:cancel": _vm.uploadCancel
        }
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              maxWidth: _vm.getMaxWidth,
              minWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.crop_modal,
            callback: function($$v) {
              _vm.crop_modal = $$v
            },
            expression: "crop_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.canceledCrop()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("crop_image")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("vue-cropper", {
                    ref: "cropper",
                    attrs: {
                      src: _vm.original_image,
                      guides: true,
                      "drag-mode": "crop",
                      "view-mode": 1,
                      "aspect-ratio": _vm.aspect_ratio
                        ? _vm.aspect_ratio
                        : 16 / 9,
                      background: true,
                      "img-style": { width: "auto", height: "500px" }
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "row q-mt-sm gutter-sm justify-end" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-4",
                          class: _vm.getOrder("cancel")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "tertiary",
                              label: _vm.$t("cancel")
                            },
                            on: {
                              click: function($event) {
                                return _vm.canceledCrop()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-4",
                          class: _vm.getOrder("crop")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: { color: "primary", label: _vm.$t("crop") },
                            on: {
                              click: function($event) {
                                return _vm.cropImage()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }